import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { MetaPixel } from './components/MetaPixel';
import { LanguageProvider } from './context/LanguageContext';
export function App() {
  useEffect(() => {
    // ── Page Title ──────────────────────────────────────────────
    document.title = "The Luxury Content System™ | The Framework Behind Alexa's Growth";
    // ── OG / Social Meta Tags ───────────────────────────────────
    const metaTags = [{
      property: 'og:title',
      content: "The Luxury Content System™ | The Framework Behind Alexa's Growth"
    }, {
      property: 'og:description',
      content: 'Stop guessing what to post. Discover the exact system Alexa used to build a luxury presence online with structure, clarity, and strategy.'
    }, {
      property: 'og:url',
      content: 'https://system.alexaaanarvaez.in'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/eNabV6EjgNXjyH8oHFnFr3/Ebook_portada.png'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:site_name',
      content: 'The Luxury Content System™'
    },
    // Twitter/X Card
    {
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:title',
      content: "The Luxury Content System™ | The Framework Behind Alexa's Growth"
    }, {
      name: 'twitter:description',
      content: 'Stop guessing what to post. Discover the exact system Alexa used to build a luxury presence online.'
    }, {
      name: 'twitter:image',
      content: 'https://cdn.magicpatterns.com/uploads/eNabV6EjgNXjyH8oHFnFr3/Ebook_portada.png'
    },
    // SEO
    {
      name: 'description',
      content: 'Stop guessing what to post. Discover the exact system Alexa used to build a luxury presence online with structure, clarity, and strategy.'
    }];
    metaTags.forEach(({
      property,
      name,
      content
    }: any) => {
      const existing = property ? document.querySelector(`meta[property="${property}"]`) : document.querySelector(`meta[name="${name}"]`);
      if (existing) {
        existing.setAttribute('content', content);
      } else {
        const meta = document.createElement('meta');
        if (property) meta.setAttribute('property', property);
        if (name) meta.setAttribute('name', name);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    });
    // ── Preconnect / DNS prefetch ───────────────────────────────
    const links = [{
      rel: 'preconnect',
      href: 'https://learn.alexaaanarvaez.in'
    }, {
      rel: 'dns-prefetch',
      href: 'https://learn.alexaaanarvaez.in'
    }, {
      rel: 'prefetch',
      href: 'https://learn.alexaaanarvaez.in/cart/43580187443265:1'
    }];
    links.forEach(({
      rel,
      href
    }) => {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = href;
      document.head.appendChild(link);
    });
  }, []);
  return <LanguageProvider data-id="element-0">
      <MetaPixel data-id="element-1" />
      <LandingPage data-id="element-2" />
    </LanguageProvider>;
}